import { useEffect } from "react";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { getNumberFromCurrency, currencyFormatter, RATE } from "./../../utils";

function Form({ formData, setInterestRateData }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
  } = useForm({
    defaultValues: {
      loanAmount: currencyFormatter(formData.loanAmount),
      loanTerm: Number(formData.loanTerm),
      monthlyPayment: currencyFormatter(formData.monthlyPayment)
    },
  });

  const calculateData = (values) => {
    const formattedValues = {
      loanAmount: getNumberFromCurrency(values.loanAmount),
      loanTerm: Number(values.loanTerm),
      monthlyPayment: getNumberFromCurrency(values.monthlyPayment),
    };

    const { loanAmount, loanTerm, monthlyPayment } = formattedValues;

    const interestRate = RATE(loanTerm, -monthlyPayment, loanAmount) * 12 * 100;
    const totalMonthlyPayments = loanTerm * monthlyPayment;
    const totalInterest = totalMonthlyPayments - loanAmount;

    setInterestRateData({
      formData,
      results: {
        interestRate: interestRate,
        totalMonthlyPayments: totalMonthlyPayments,
        totalInterest: totalInterest
      },
    });
  };

  useEffect(() => {
    calculateData(getValues());
  }, []);

  return (
    <div className="InterestRateAppForm">
      <form autoComplete="off" onSubmit={handleSubmit(calculateData)}>
        <fieldset>
          <label htmlFor="loanAmount">Loan Amount</label>
          <input
            type="text"
            id="loanAmount"
            className={classNames("InterestRateAppFormField", {
              InterestRateAppFormFieldError: errors.loanAmount,
            })}
            {...register("loanAmount", {
              required: true,
              validate: {
                positive: (value) => {
                  return !isNaN(getNumberFromCurrency(value));
                },
              },
              onBlur: (event) => {
                const value =
                  event.target.value.trim().length === 0
                    ? event.target.value
                    : getNumberFromCurrency(event.target.value);
                const formattedValue =
                  isNaN(value) || event.target.value.trim().length === 0
                    ? event.target.value
                    : currencyFormatter(value);
                setValue("loanAmount", formattedValue);
              },
            })}
            aria-invalid={errors.loanAmount ? "true" : "false"}
          />
        </fieldset>
        <fieldset>
          <label htmlFor="loanTerm">Loan Term (Months)</label>
          <input
            type="text"
            id="loanTerm"
            className={classNames("InterestRateAppFormField", {
              InterestRateAppFormFieldError: errors.loanTerm,
            })}
            {...register("loanTerm", {
              required: true,
            })}
            aria-invalid={errors.loanTerm ? "true" : "false"}
          />
        </fieldset>
        <fieldset>
          <label htmlFor="monthlyPayment">Monthly Payment</label>
          <input
            type="text"
            id="monthlyPayment"
            className={classNames("InterestRateAppFormField", {
              InterestRateAppFormFieldError: errors.monthlyPayment,
            })}
            {...register("monthlyPayment", {
              required: true,
              validate: {
                positive: (value) => {
                  return !isNaN(getNumberFromCurrency(value));
                },
              },
              onBlur: (event) => {
                const value =
                  event.target.value.trim().length === 0
                    ? event.target.value
                    : getNumberFromCurrency(event.target.value);
                const formattedValue =
                  isNaN(value) || event.target.value.trim().length === 0
                    ? event.target.value
                    : currencyFormatter(value);
                setValue("monthlyPayment", formattedValue);
              },
            })}
            aria-invalid={errors.monthlyPayment ? "true" : "false"}
          />
        </fieldset>
        <button type="submit">Calculate</button>
      </form>
    </div>
  );
}

export default Form;
